import { Col, Divider, Image, Row, Typography } from "antd"
import { useContext } from "react"
import { ModalCharterContext } from "."
import { Controller } from "react-hook-form"
import { useTETranslation } from "@/hooks/app/useTETranslation"
import { useTranslation } from "react-i18next"
import ControllerGroup from "../ControllerGroup"
import Text from "../Typography/Text"

const CharterFormBook = () => {
  const { form } = useContext(ModalCharterContext)
  const { getFormatCurrency } = useTETranslation()
  const { t } = useTranslation()

  return (
    <Row justify='center' gutter={15}>
      <Col span={24}>
        <Row justify='center' gutter={[15, 15]}>
          <Col flex={"35rem"}>
            <Row gutter={10} wrap={false}>
              <Col flex={"17rem"}>
                <Typography.Text strong type='secondary'>{t("common.bank_account_title")}</Typography.Text>
              </Col>
              <Col>
                :
              </Col>
              <Col flex={1}>
                <Typography.Text style={{ width: '100%' }} ellipsis>CONG TY TNHH DU LICH LU HANH THAT DE</Typography.Text>
              </Col>
            </Row>
            <Divider style={{ marginBlock: '1rem' }} />
            <Row gutter={10} wrap={false}>
              <Col flex={"17rem"}>
                <Typography.Text strong type='secondary'>{t("common.bank_account_bank")}</Typography.Text>
              </Col>
              <Col>
                :
              </Col>
              <Col flex={1}>
                <Typography.Text style={{ width: '100%' }} ellipsis strong>EIB NAM SAI GON</Typography.Text>
              </Col>
            </Row>
            <Divider style={{ marginBlock: '1rem' }} />
            <Row gutter={10} wrap={false}>
              <Col flex={"17rem"}>
                <Typography.Text strong type='secondary'>{t("common.bank_account_number")}:</Typography.Text>
              </Col>
              <Col>
                :
              </Col>
              <Col flex={1}>
                <Typography.Text ellipsis style={{ width: '100%' }} copyable>0318597564</Typography.Text>
              </Col>
            </Row>
            <Divider style={{ marginBlock: '1rem' }} />
            <Row gutter={10} wrap={false}>
              <Col flex={"17rem"}>
                <Typography.Text strong type='secondary'>{t("booking.total_amount")}</Typography.Text>
              </Col>
              <Col>
                :
              </Col>
              <Col flex={1}>
                <Controller
                  control={form?.control}
                  name="passengers"
                  render={({ field }) => {
                    return (
                      <Typography.Text style={{ width: '100%' }} ellipsis copyable={{ text: `${900000 * field.value.length}` }} strong type='danger'>{getFormatCurrency(900000 * field.value.length)}</Typography.Text>
                    )
                  }}
                />
              </Col>

            </Row>
            <Divider style={{ marginBlock: '1rem' }} />
            <Row gutter={10} wrap={false}>
              <Col flex={"17rem"}>
                <Typography.Text strong type='secondary'>{t("common.content")}</Typography.Text>
              </Col>
              <Col>
                :
              </Col>
              <Col flex={1}>
                <ControllerGroup
                  form={form as any}
                  names={["orderCode", "contact.phone"]}
                  render={({ fields: [field, orderCode] }) => {
                    return (
                      <Typography.Text style={{ width: '100%' }} ellipsis copyable>{orderCode.value} {field.value}</Typography.Text>
                    )
                  }}
                />
              </Col>
            </Row>
            <Divider style={{ marginBlock: '1rem' }} />
            <Row>
              <Text>
                <Text type='danger'>*</Text> {t("flight.charter_payment_note", { phone: process.env.NEXT_PUBLIC_COMPANY_PHONE })}
              </Text>
            </Row>
          </Col>
          <Col>
            <Image
              style={{ borderRadius: 8 }}
              wrapperStyle={{ width: '100%' }}
              preview={false}
              src="/static/images/qr-thanh-toan.png"
              alt="QR ngân hàng thanh toán"
            />
          </Col>

        </Row>
      </Col>
    </Row>
  )
}

export default CharterFormBook